export default class FeedbackForm {

  constructor (el) {
    this.el = el
    this.plate = this.el.querySelector('.js-feedback-form-plate')
    this.content = this.el.querySelector('.js-feedback-form-content')
    this.btn = this.el.querySelector('.js-feedback-form-btn')
  }

  init () {
    this.initEvents()
  }

  initEvents () {
    this.btn.addEventListener('click', e => this.openForm(e))
  }

  openForm (e) {
    e.preventDefault()

    $(this.plate).fadeOut(300).promise().done(() => {
      $(this.content).fadeIn(600)
    })
  }

}